"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _grid = require("./grid.styles");

var _clsx = _interopRequireDefault(require("../utils/clsx"));

var _withDefaults = _interopRequireDefault(require("../utils/with-defaults"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const defaultProps = {
  xs: false,
  sm: false,
  md: false,
  lg: false,
  xl: false,
  className: ''
};

const getItemLayout = val => {
  const display = val === 0 ? 'none' : 'inherit';

  if (typeof val === 'number') {
    const width = 100 / 12 * val;
    const ratio = width > 100 ? '100%' : width < 0 ? '0' : `${width}%`;
    return {
      flexGrow: 0,
      display,
      maxWidth: ratio,
      flexBasis: ratio
    };
  }

  return {
    flexGrow: 1,
    display,
    maxWidth: '100%',
    flexBasis: '0'
  };
};

const GridItem = ({
  xs,
  sm,
  md,
  lg,
  xl,
  css,
  justify,
  direction,
  alignItems,
  alignContent,
  children,
  className,
  ...props
}) => {
  const classes = (0, _react.useMemo)(() => {
    const breaks = {
      xs,
      sm,
      md,
      lg,
      xl
    };
    const classString = Object.keys(breaks).reduce((pre, name) => {
      if (breaks[name] !== undefined && breaks[name] !== false) return `${pre} ${name}`;
      return pre;
    }, '');
    return classString.trim();
  }, [xs, sm, md, lg, xl]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_grid.StyledGridItem, {
    className: (0, _clsx.default)('nextui-grid-item', classes, className),
    css: {
      alignItems,
      alignContent,
      justifyContent: justify,
      flexDirection: direction,
      '&.xs': { ...getItemLayout(xs)
      },
      '@xsMax': {
        '&.xs': { ...getItemLayout(xs)
        }
      },
      '@sm': {
        '&.sm': { ...getItemLayout(sm)
        }
      },
      '@md': {
        '&.md': { ...getItemLayout(md)
        }
      },
      '@lg': {
        '&.lg': { ...getItemLayout(lg)
        }
      },
      '@xl': {
        '&.xl': { ...getItemLayout(xl)
        }
      },
      ...css
    },
    ...props,
    children: children
  });
};

GridItem.toString = () => '.nextui-grid-item';

var _default = (0, _withDefaults.default)(GridItem, defaultProps);

exports.default = _default;
module.exports = exports.default;